/* BITCO auto-localization: on a visitor's first pageview, ask Shopify which
   country/language fits them (GeoIP + Accept-Language via the
   browsing_context_suggestions Ajax API) and switch the storefront context so
   prices show in their market's currency (Markets: UK→GBP, CH→CHF, …) and the
   page uses their language. Runs ONCE per browser (bitco:loc-auto); any manual
   use of a localization form sets bitco:loc-manual and permanently wins. */
(() => {
  if (window.__bitcoGeoBound) return;
  window.__bitcoGeoBound = true;
  if (window.Shopify && window.Shopify.designMode) return;

  const KEY_AUTO = 'bitco:loc-auto';
  const KEY_MANUAL = 'bitco:loc-manual';

  const script = document.currentScript;
  const current = {
    country: (script && script.dataset.country) || '',
    language: (script && script.dataset.language) || '',
  };
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const storage = {
    get(key) {
      try { return window.localStorage.getItem(key); } catch (e) { return null; }
    },
    set(key, value) {
      try { window.localStorage.setItem(key, value); } catch (e) { /* private mode */ }
    },
  };

  // A manual pick in ANY localization form (header dropdown, drawer selects)
  // must permanently silence auto-switching.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form && typeof form.action === 'string' && form.action.indexOf('/localization') !== -1 && !form.hasAttribute('data-bitco-geo-form')) {
      storage.set(KEY_MANUAL, '1');
    }
  }, true);

  if (!current.country || storage.get(KEY_MANUAL) || storage.get(KEY_AUTO)) return;

  const pickHandle = (part) => {
    if (!part) return null;
    if (typeof part.handle === 'string') return part.handle;
    return null;
  };

  const applyLocalization = (country, language) => {
    // Flag BEFORE navigating so the reloaded page never re-runs detection.
    storage.set(KEY_AUTO, country + '/' + (language || ''));
    const form = document.createElement('form');
    form.action = root + 'localization';
    form.method = 'POST';
    form.hidden = true;
    form.setAttribute('data-bitco-geo-form', '');
    const fields = {
      _method: 'PUT',
      country_code: country,
      language_code: language || current.language,
      return_to: window.location.pathname + window.location.search,
    };
    Object.keys(fields).forEach((name) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = fields[name];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  };

  const run = () => {
    const url = root
      + 'browsing_context_suggestions.json'
      + '?country%5Benabled%5D=true'
      + '&country%5Bexclude%5D=' + encodeURIComponent(current.country)
      + '&language%5Benabled%5D=true'
      + '&language%5Bexclude%5D=' + encodeURIComponent(current.language);

    fetch(url)
      .then((response) => (response.ok ? response.json() : Promise.reject(new Error('bad response'))))
      .then((data) => {
        const detected = data && data.detected_values ? data.detected_values : {};
        const suggestion = data && data.suggestions && data.suggestions[0] && data.suggestions[0].parts
          ? data.suggestions[0].parts
          : {};
        const country = pickHandle(detected.country) || pickHandle(suggestion.country);
        const language = pickHandle(detected.language) || pickHandle(suggestion.language);

        const countryChanged = country && country !== current.country;
        const languageChanged = language && language !== current.language;
        if (countryChanged || languageChanged) {
          applyLocalization(countryChanged ? country : current.country, languageChanged ? language : current.language);
        } else {
          // Detection matched the defaults — remember so we don't refetch forever.
          storage.set(KEY_AUTO, current.country + '/' + current.language);
        }
      })
      .catch(() => { /* offline/blocked: try again next pageview */ });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
